const url = require('url');
const queryString = require('querystring');

const contentURLMapper = (rawUrl, isHead = false) => {
  const contentBasePath = 'content-renderer';
  const parsedUrl = url.parse(rawUrl);
  const pathName = parsedUrl.pathname;
  const plainQueryString = parsedUrl.query;

  const parsedQueryString = queryString.parse(plainQueryString);
  const id = pathName && pathName !== '/' ? pathName : '/homepage';

  const pathWithoutTrailingSlash = pathName.endsWith('/')
    ? pathName.substr(0, pathName.length - 1)
    : pathName;

  if (isHead) {
    const { section } = parsedQueryString;
    const sectionParams = section ? `section=${section}&` : ``;
    return pathWithoutTrailingSlash === ''
      ? '/content-renderer/homepage.head'
      : `/content-renderer${pathWithoutTrailingSlash}.head?${sectionParams}includeMetadata=true`;
  } else {
    return plainQueryString
      ? `/${contentBasePath}${id}?experimentsEnabled=true&includeCoreJS=false&includePolyfills=false&${plainQueryString}&isJoyfullyBold=true`
      : `/${contentBasePath}${id}?experimentsEnabled=true&includeCoreJS=false&includePolyfills=false&isJoyfullyBold=true`;
  }
};

export default contentURLMapper;
